import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// إعداد Query Client مع الكاش
const createQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      // حفظ البيانات في الكاش لمدة 5 دقائق
      staleTime: 5 * 60 * 1000,
      // الاحتفاظ بالبيانات في الذاكرة لمدة 10 دقائق
      cacheTime: 10 * 60 * 1000,
      // إعادة جلب البيانات عند استعادة النافذة
      refetchOnWindowFocus: true,
      // إعادة جلب البيانات عند إعادة الاتصال
      refetchOnReconnect: true,
      // عدم إعادة المحاولة عند الفشل تلقائياً
      retry: 1,
    },
  },
});

export const QueryProvider = ({ children }) => {
  const [queryClient] = React.useState(createQueryClient);
  React.useEffect(() => () => queryClient.clear(), [queryClient]);
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

